import { service } from "../utils/request";

// 支付宝
//获取配置信息
export function zhifubaoList(data) {
  return service({
    url: "/api/config.Single_Alipay/index",
    method: "post",
    data: data
  });
}
//设置配置信息
export function zhifubaoSet(data) {
  return service({
    url: "/api/config.Single_Alipay/set",
    method: "post",
    data: data
  });
}

// 微信
export function weixinList(data) {
  return service({
    url: "/api/config.single_wechat/index",
    method: "post",
    data: data
  });
}
// 微信删除
export function weixinDel(data) {
  return service({
    url: "/api/config.single_wechat/del",
    method: "post",
    data: data
  });
}
// 支付配置列表
export function payType(data) {
  return service({
    url: "/api/config.pay_type/index",
    method: "post",
    data: data
  });
}
// 支付修改状态
export function payStatus(data) {
  return service({
    url: "/api/config.pay_type/setting",
    method: "post",
    data: data
  });
}
// 银联
export function unionData(data) {
  return service({
    url: "/api/config.union/index",
    method: "post",
    data: data
  });
}
// 银联修保存
export function unionStatus(data) {
  return service({
    url: "/api/config.union/saveConfig",
    method: "post",
    data: data
  });
}
// 通联
export function tongunionData(data) {
  return service({
    url: "api/config.allinpay/index",
    method: "post",
    data: data
  });
}
// 通联修保存
export function tongunionStatus(data) {
  return service({
    url: "api/config.allinpay/saveConfig",
    method: "post",
    data: data
  });
}
// 余额
export function balanceData(data) {
  return service({
    url: "api/config.Balance_Pay/index",
    method: "post",
    data: data
  });
}
// 余额修保存
export function balanceStatus(data) {
  return service({
    url: "api/config.Balance_Pay/set",
    method: "post",
    data: data
  });
}
// 富友详情
export function fuiouInfo(data) {
  return service({
    url: "api/config.fuiou_pay/index",
    method: "post",
    data: data
  });
}
// 富友修改保存
export function setFuiou(data) {
  return service({
    url: "api/config.fuiou_pay/set",
    method: "post",
    data: data
  });
}

// 扫码支付轮询
export function order_status(data) {
  return service({
    url: "creditshop/agent.creditshop_goods_order/order_status",
    method: "post",
    data: data
  });
}
export function psw_config(data) {
  return service({
    url: "api/tool/safe_config",
    method: "post",
    data: data
  });
}
//生成支付二维码
export function createPayQrcode(data) {
  return service({
    url: "offlinestore/agent.order/createPayQrcode",
    method: "post",
    data: data
  });
}
//查询支付进度
export function checkPayQrcodeStatus(data) {
  return service({
    url: "offlinestore/agent.order/checkPayQrcodeStatus",
    method: "post",
    data: data
  });
}
